import { createSelector } from 'reselect'

import { selectFinSobState } from './selectFinSobState'

/** The plan's changes or a category's not-applicable switch are on their way to the server. */
export const selectIsFinSobSaving = createSelector(
  [selectFinSobState],
  ({ isApplicableSwitcherLoading, isCategoryPlanningApplyingChangesLoading }) =>
    isApplicableSwitcherLoading || isCategoryPlanningApplyingChangesLoading
)
